import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FaqSection } from "@/components/FaqSection";
import { PartnersSection } from "@/components/PartnersSection";
import { SEOHead } from "@/components/SEOHead";
import { RubroProvider } from "@/components/home/rubro";
import { HomeHero } from "@/components/home/HomeHero";
import { HomeFacts } from "@/components/home/HomeFacts";
import { HomeMarquee } from "@/components/home/HomeMarquee";
import { HomeProblem } from "@/components/home/HomeProblem";
import { HomeFlow } from "@/components/home/HomeFlow";
import { HomeSystemPreview } from "@/components/home/HomeSystemPreview";
import { HomeCompare } from "@/components/home/HomeCompare";
import { HomeWhoDoesWhat } from "@/components/home/HomeWhoDoesWhat";
import { HomeModules } from "@/components/home/HomeModules";
import { HomeAudience } from "@/components/home/HomeAudience";
import { HomeProcess } from "@/components/home/HomeProcess";
import { HomeCases } from "@/components/home/HomeCases";
import { HomeTestimonials } from "@/components/home/HomeTestimonials";
import { HomePrice } from "@/components/home/HomePrice";
import { HomeCta } from "@/components/home/HomeCta";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="CreceLocal: Más Clientes, Menos Oportunidades Perdidas"
        description="CreceLocal arma el sistema completo para que te encuentren en Google, respondas cada consulta y hagas seguimiento sin estar atrás de todo. Para empresas de servicios, distribuidoras y mayoristas."
        canonical="/"
        schemaJson={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "CreceLocal",
          url: "https://crecelocal.com",
          description:
            "CreceLocal arma el sistema completo para conseguir, atender, seguir y recuperar clientes. Para empresas de servicios y distribuidores en Buenos Aires, Argentina.",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Buenos Aires",
            addressRegion: "CABA",
            addressCountry: "AR",
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: -34.6037385,
            longitude: -58.3815704,
          },
          telephone: "+54 9 11 2372 9528",
          areaServed: "Buenos Aires, Argentina",
        }}
      />
      <Navbar />
      <main>
        <RubroProvider>
          {/* 02 — HERO */}
          <HomeHero />
          {/* FACTS */}
          <HomeFacts />
          {/* 03 — PRUEBA RÁPIDA (marquee de rubros) */}
          <HomeMarquee />
          {/* 04 — PROBLEMAS */}
          <HomeProblem />
          {/* 05 — CÓMO FUNCIONA (recorrido interactivo) */}
          <HomeFlow />
          {/* 06 — POR DENTRO (preview del sistema) */}
          <HomeSystemPreview />
          {/* 07 — ANTES / DESPUÉS */}
          <HomeCompare />
          {/* 08 — QUIÉN HACE QUÉ */}
          <HomeWhoDoesWhat />
          {/* 09 — MÓDULOS (siete piezas, un sistema) */}
          <HomeModules />
          {/* 10 — PARA QUIÉN + ES PARA VOS / NO ES PARA VOS */}
          <HomeAudience />
          {/* 11 — CÓMO TRABAJAMOS */}
          <HomeProcess />
          {/* 12 — CASOS REALES */}
          <HomeCases />
          {/* 13 — TESTIMONIOS */}
          <HomeTestimonials />
        </RubroProvider>
        {/* Integraciones (muy pequeño) */}
        <PartnersSection />
        {/* PRECIO */}
        <HomePrice />
        {/* 14 — FAQ */}
        <FaqSection />
        {/* 15 — CTA FINAL */}
        <HomeCta />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
